<style lang="stylus">
    .wb-header
        position relative
        padding-left 48px
        height 27px
        margin-bottom 16px
        &.noPaddingLeft
            padding-left 0
        .back
            display flex
            align-items center
            width fit-content
            pointer-events auto
            user-select: none;
            font-size: 12px;
            border-radius: 4px;
            border 1px solid #dcdee2
            line-height 32px
            background #fff
            height 32px;
            padding: 0px 15px;
            cursor pointer
            transition: color .2s linear,background-color .2s linear,border .2s linear,box-shadow .2s linear,-webkit-box-shadow .2s linear;
            &:hover
                color: #82a2fc;
                background-color: #fff;
                border-color: #82a2fc;
        .files-path
            position relative
            color #000
            font-size 18px
            display flex
            align-self flex-start
            div
                margin-right 4px
                max-width 200px
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                cursor pointer
                pointer-events auto
            .selected-path
                font-weight bold
        .cloudfile-head
            .files-path
                .files-path-box
                    position absolute
                    top 30px
                    left 70px
                    width 200px
                    max-height 250px
                    cursor pointer
                    overflow-y auto
                    border-radius 3px
                    background-color #fff
                    box-shadow $box-shadow
                    z-index 10
                    pointer-events auto
                    li
                        max-width 200px
                        padding 7px 10px
                        font-size 13px
                        color #353535
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        transition background-color .2s linear
                        &:hover
                            background-color $main-hovercolor
                            cursor pointer
</style>

<template>
    <div class="wb-header" :class="{ noPaddingLeft: outside }">
        <div class="history-head" v-if="from == 'history'">
            <div class="files-path" v-if="!historySearchMode">
                <div class="selected-path">{{ $t("historyTitle") }}</div>
            </div>
            <div class="back" v-if="historySearchMode" @click="searchBack()">< {{ $t("return") }}</div>
        </div>

        <div class="cloudfile-head" v-if="from == 'cloundFile'">
            <div class="files-path" v-if="!clodFileSearchMode" v-click-outside="closePathBox">
                <div :class="{ 'selected-path': path.length == 0 }" @click="setPath(null)">{{ $t("personal") }}</div>
                <div
                    v-if="path.length < 6"
                    v-for="(item, index) in path"
                    :key="index"
                    :class="{ 'selected-path': path.length == index + 1 }"
                    @click="setPath(index)"
                >
                    > {{ item }}
                </div>
                <div ref="pathBox" v-if="path.length >= 6" @click="pathBox()">> ...</div>
                <ul v-show="showPathBox" class="files-path-box">
                    <li v-if="index != path.length - 1" v-for="(item, index) in path" :key="index" @click="setPath(index)">
                        {{ item }}
                    </li>
                </ul>
                <div v-if="path.length >= 6" class="selected-path" @click="setPath(path.length - 1)">> {{ path[path.length - 1] }}</div>
            </div>
            <div class="back" v-if="clodFileSearchMode" @click="searchBack()">< {{ $t("allFiles") }}</div>
        </div>

        <div class="star-head" v-if="from == 'star'">
            <div class="files-path" v-if="!starSearchMode">
                <div class="selected-path">{{ $t("star") }}</div>
            </div>
            <div class="back" v-if="starSearchMode" @click="searchBack()">< {{ $t("return") }}</div>
        </div>

        <div class="shareToMe-head" v-if="from == 'shareToMe'">
            <div class="files-path" v-if="!shareToMeSearchMode">
                <div class="selected-path">{{ $t("shareToMe") }}</div>
            </div>
            <div class="back" v-if="shareToMeSearchMode" @click="searchBack()">< {{ $t("return") }}</div>
        </div>

        <div class="publish-head" v-if="from == 'publish'">
            <div class="files-path" v-if="!publishSearchMode">
                <div class="selected-path">{{ $t("publish") }}</div>
            </div>
            <div class="back" v-if="publishSearchMode" @click="searchBack()">< {{ $t("return") }}</div>
        </div>

        <div class="publish-head" v-if="from == 'collect'">
            <div class="files-path" v-if="!collectSearchMode">
                <div class="selected-path">{{ $t("collect") }}</div>
            </div>
            <div class="back" v-if="collectSearchMode" @click="searchBack()">< {{ $t("return") }}</div>
        </div>

        <div class="publish-head" v-if="from == 'recycle'">
            <div class="files-path" v-if="!recycleSearchMode">
                <div class="selected-path">{{ $t("recycle") }}</div>
            </div>
            <div class="back" v-if="recycleSearchMode" @click="searchBack()">< {{ $t("return") }}</div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class WbHeader extends Vue {
        @Prop()
        from;
        @Prop({
            default: false,
        })
        outside; // 是工作台外部使用，需去除padding-left

        // public
        get nowRef() {
            if (this.from == "history") {
                return "historyView";
            } else if (this.from == "cloundFile") {
                return "files";
            } else if (this.from == "star") {
                return "star";
            } else if (this.from == "shareToMe") {
                return "shareToMe";
            } else if (this.from == "publish") {
                return "publishFile";
            }
        }
        searchBack() {
            this.$emit("wbHeaderEvent", {
                ref: this.nowRef,
                func_name: "searchBack",
                args: null,
            });
        }
        // history
        get historySearchMode() {
            return this.$store.state.history.searchMode;
        }

        // cloudFile
        get path() {
            return this.$store.state.cloudFile.path;
        }
        get clodFileSearchMode() {
            return this.$store.state.cloudFile.searchMode;
        }
        showPathBox = false;
        setPath(index) {
            this.$emit("wbHeaderEvent", {
                ref: "files",
                func_name: "setPath",
                args: index,
            });
            this.$bus.$emit("refreshEv");
        }
        pathBox() {
            this.showPathBox = true;
        }
        closePathBox() {
            this.showPathBox = false;
        }
        // star
        get starSearchMode() {
            return this.$store.state.star.searchMode;
        }

        // share2me
        get shareToMeSearchMode() {
            return this.$store.state.shareToMe.searchMode;
        }

        // publish
        get publishSearchMode() {
            return this.$store.state.publish.searchMode;
        }

        // collect
        get collectSearchMode() {
            return this.$store.state.collect.searchMode;
        }

        // recycle
        get recycleSearchMode() {
            return this.$store.state.recycle.searchMode;
        }

        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "return": "返回",
        "historyTitle": "历史浏览",
        "allFiles": "所有文件",
        "personal": "个人云",
        "star": "星标文件",
        "shareToMe": "分享给我",
        "publish": "我的发布",
        "collect": "模板收藏",
        "recycle": "回收站"
    },
    "en": {
        "return": "Return",
        "historyTitle": "Historical browsing",
        "allFiles": "All Files",
        "personal": "Personal",
        "star": "Starred File",
        "shareToMe": "Share with me",
        "publish": "Publish",
        "collect": "Template Likes",
        "recycle": "Recycle bin"
    },
    "fr": {
        "return": "retour",
        "historyTitle": "Navigation historique",
        "allFiles": "Tous les fichiers",
        "personal": "Cloud personnel",
        "star": "Fichier étoil",
        "shareToMe": "Partage avec moi",
        "publish": "Publier",
        "collect": "Modèle de mentions J'aime",
        "recycle": "Corbeille"
    },
    "de": {
        "historyTitle": "Historisches Browsen",
        "return": "Rückkehr",
        "allFiles": "Alle Dateien",
        "personal": "Persönlicher Cloud",
        "star": "Sternendatei",
        "shareToMe": "Teile mit mir",
        "publish": "Veröffentlichen",
        "collect": "Vorlagen mit Likes",
        "recycle": "Papierkorb"
    },
    "jp": {
        "historyTitle": "閲覧履歴",
        "return": "戻る",
        "allFiles": "すべてのファイル",
        "personal": "個人クラウド",
        "star": "スターファイル",
        "shareToMe": "私との共有",
        "publish": "投稿",
        "collect": "テンプレートのいいね",
        "recycle": "ゴミ箱"
    },
    "es": {
        "historyTitle": "Historial",
        "return": "regreso",
        "allFiles": "Todos los archivos",
        "personal": "Nube Personal",
        "star": "Estrellas archivos",
        "shareToMe": "Compartido conmigo",
        "publish": "Publicar",
        "collect": "Me gusta de la plantilla",
        "recycle": "Papelera"
    },
    "pt": {
        "historyTitle": "Navegação histórica",
        "return": "Retorna",
        "allFiles": "Todos os Ficheiros",
        "personal": "Pessoal",
        "star": "Documentos estrelados",
        "shareToMe": "Compartilhe comigo",
        "publish": "Publicar",
        "collect": "Modelos curtidos",
        "recycle": "Pasta de Reciclagem"
    },
    "it": {
        "historyTitle": "Navigazione storica",
        "return": "ritorno",
        "allFiles": "Tutti i File",
        "personal": "Personali",
        "star": "File Stella",
        "shareToMe": "Condividi con me",
        "publish": "Pubblicare",
        "collect": "Modelli con Mi piace",
        "recycle": "Cestino"
    },
    "tw": {
        "return": "返回",
        "historyTitle": "歷史瀏覽",
        "allFiles": "所有檔案",
        "personal": "個人雲端硬碟",
        "star": "星標檔案",
        "shareToMe": "分享給我",
        "publish": "發佈",
        "collect": "喜愛的範本",
        "recycle": "回收站"
    },
    "kr": {
        "return": "돌아가기",
        "historyTitle": "조회 기록",
        "allFiles": "모든 파일",
        "personal": "개인 클라우드",
        "star": "별표 파일",
        "shareToMe": "공유된 파일",
        "publish": "게시",
        "collect": "좋아하는 템플릿",
        "recycle": "휴지통"
    },
    "id": {
        "return": "Kembali",
        "historyTitle": "Penelusuran historis",
        "allFiles": "Semua File",
        "personal": "Personal",
        "star": "File Berbintang",
        "shareToMe": "Bagikan dengan saya",
        "publish": "Terbitkan",
        "collect": "Favorit Saya",
        "recycle": "Tempat sampah"
    }
}
</i18n>
